<template>

    <div class="text-base text-theme-main px-6 mt-4">

        <p class="font-bold mb-6">{{ translate('comments') }}</p>

        <div v-if="currentUser" class="mb-8">
            <comment-form :language="language" :content_id="content_id" :button_label="buttonLabel"></comment-form>
        </div>
        <div v-else>
            <p class="font-bold mb-6">{{translate('comments-must-login') }}</p>
        </div>

        <!--<comment-list :language="language" :full_data="this.$root.shared.full_comment_data" data_key="root" :content_id="content_id" is_first="true"></comment-list>-->
        <comment-list :language="language" data_key="root" :content_id="content_id" is_first="true"></comment-list>

    </div>

</template>


<script>

    const Lang = require('lang.js');
    import translations from './messages.js';

    const lang = new Lang();

    lang.setMessages(translations);

    export default {

        props: [

            'language',
            'content_id'

        ],

        data() {

            return {

                currentUser: Laravel.user,
                buttonLabel: Laravel.user ? this.translate('comments-as') + Laravel.user.name : this.translate('comments-please-login')

            }

        },

        methods: {

            translate(key) {
                key = 'strings.' + key;
                return lang.get(key);
            },

        }

    }

</script>
